import React, { FC, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { useFormValidation } from '../../../hooks/useFormValidation'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { hideModal } from '../../../store/actions/modalActions'
import { Body } from './components/Body'
import { Footer } from './components/Footer'
import { initialStateWithLogSources } from './types'
import { convertDatesToSendFormat, Period } from './utils'
import Loader from '../../Loader/Loader'
import { selectModalData } from '../../../store/selectors/modalSelectors'
import { selectLogsIsLoading } from '../../../store/selectors/logsSelectors'
import { fetchProductLogs } from '../../../store/async-thunks/logs/fetchProductLogs'
import { selectOneSystemAction } from '../../../store/selectors/systemActionsSelectors'
import styles from './styles/index.module.scss'

export const LogsModal: FC = () => {
    const dispatch = useAppDispatch()
    const isLoading = useAppSelector(selectLogsIsLoading)
    const data = useAppSelector(selectModalData)
    const isServerLogs = data.isServerLogs
    const hasGetLogSources = useAppSelector(
        selectOneSystemAction(data.guid, 'get_log_sources')
    )

    const [logsState, setLogsState] = useFormValidation(
        initialStateWithLogSources,
        {}
    )

    useEffect(() => {
        if (data.productLogs) {
            dispatch(fetchProductLogs())
            const interval = setInterval(
                () => dispatch(fetchProductLogs()),
                10000
            )
            return () => clearInterval(interval)
        }
    }, [dispatch])

    const handleClose = (): void => {
        dispatch(hideModal())
    }

    const handleOnSubmit = (): void => {
        const period: Period = convertDatesToSendFormat(logsState)
        const logSourcePath = logsState.logSource?.value
        data.dispatcher?.(period, logSourcePath)
    }

    return (
        <>
            <div className="bg-blur" />
            <Modal
                centered
                show={true}
                onHide={handleClose}
                dialogClassName={styles.customModal}
            >
                <Modal.Header
                    style={{ padding: '16px 32px' }}
                    closeButton
                >
                    <Modal.Title>
                        <FormattedMessage
                            id={
                                data.productLogs
                                    ? 'modals.logs.productTitle'
                                    : 'modals.logs.serverTitle'
                            }
                        />
                    </Modal.Title>
                </Modal.Header>
                <div style={{ padding: '24px 32px' }}>
                    {isLoading ? (
                        <div className="d-flex justify-content-center">
                            <Loader />
                        </div>
                    ) : (
                        <Body
                            isProductLogSourceEnabled={!!hasGetLogSources}
                            isServerLogs={!!isServerLogs}
                            guid={data.guid}
                            logsState={logsState}
                            setLogsState={setLogsState}
                        />
                    )}
                </div>
                <div>
                    <Footer handleOnSubmit={handleOnSubmit} />
                </div>
            </Modal>
        </>
    )
}
